import { combineReducers } from 'redux';

import { reducer as unblockIP } from './unblockipModule';

export default combineReducers({
	unblockIP,
});
